/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";

interface Props {
  lotUsageDetails: any;
  batchInfo: any;
  t: any;
}

const LotUsageMetadataCards: React.FC<Props> = ({
  lotUsageDetails,
  batchInfo,
  t
}) => {
  return (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm">
            <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1">{t('mediaPowder.lotDetails.expiryDate')}</p>
            <p className="text-base font-black text-slate-800">{lotUsageDetails?.shelf_life_expiry_date || "-"}</p>
          </div>
          <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm">
            <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1">{t('mediaPowder.lotDetails.openedDate')}</p>
            <p className="text-base font-black text-slate-800">{lotUsageDetails?.opened_date || "-"}</p>
          </div>
          <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm">
            <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1">{t('mediaPowder.lotDetails.shelfLife')}</p>
            <p className="text-base font-black text-slate-800">{batchInfo?.shelf_life_days || "-"}</p>
          </div>
          <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm">
            <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1">{t('mediaPowder.lotDetails.gpt.gptStatus')}</p>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-emerald-500"></span>
              <p className="text-base font-black text-emerald-600 uppercase">{lotUsageDetails?.batch?.gpt_test_status || "-"}</p>
            </div>
          </div>
        </div>
  );
};

export default LotUsageMetadataCards;